import React from 'react';
import { DialogHeading, DialogList, DialogSection, DialogText } from '../styles/DialogStyles';

function LittlewoodsBnplDialogContent() {
  return (
    <>
      <DialogSection>
        <DialogHeading data-testid="bnpl-question-1" size="1" tag="h2" type="heading">
          What is Buy Now Pay Later (BNPL)?
        </DialogHeading>

        <DialogText data-testid="bnpl-question-1-answer-1" size="1" tag="p" type="paragraph">
          BNPL is an interest bearing option that allows you to delay payments on your purchases for up to 12 months.
          The delayed payment period starts from the date of order (including pre-ordered items and those not ready for
          immediate dispatch).
        </DialogText>

        <DialogText data-testid="bnpl-question-1-answer-2" size="1" tag="p" type="paragraph">
          You can choose:
        </DialogText>

        <DialogList>
          <li>
            <DialogText data-testid="bnpl-question-1-answer-3" size="1" tag="p" type="paragraph">
              A delayed payment period of 12 months and then a repayment period of 104 weeks when you spend £50 or more.
            </DialogText>
          </li>
          <li>
            <DialogText data-testid="bnpl-question-1-answer-4" size="1" tag="p" type="paragraph">
              A delayed payment period of 12 months and then a repayment period of 156 weeks when you spend £99 or more
            </DialogText>
          </li>
        </DialogList>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-2" size="1" tag="h2" type="heading">
          How is interest calculated?
        </DialogHeading>

        <DialogText data-testid="bnpl-question-2-answer-1" size="1" tag="p" type="paragraph">
          Interest will be charged for the delayed payment period and the chosen repayment period.
        </DialogText>

        <DialogText data-testid="bnpl-question-2-answer-2" size="1" tag="p" type="paragraph">
          Interest is calculated and compounded daily at a typical rate of 44.9% per annum for the delayed payment
          period and repayment period and is charged to your account at date of order as a lump sum. This calculation
          factors in the planned payments that are requested during the repayment period. Your interest rate is personal
          to you and will be detailed in checkout
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-3" size="1" tag="h2" type="heading">
          How do I avoid paying interest?
        </DialogHeading>

        <DialogText data-testid="bnpl-question-3-answer-1" size="1" tag="p" type="paragraph">
          You can avoid paying all interest for both periods by paying the cash price before the end of the delayed
          payment period. This can be done in one full payment or multiple partial payments.
        </DialogText>

        <DialogText data-testid="bnpl-question-3-answer-2" size="1" tag="p" type="paragraph">
          Making partial payments may result in a portion of the lump sum of compound interest being refunded at the end
          of the delayed payment period.
        </DialogText>

        <DialogText data-testid="bnpl-question-3-answer-3" size="1" tag="p" type="paragraph">
          <strong>
            Remember if you choose not to pay the full cash price before the end of the delayed payment period any
            outstanding balance plus the lump sum of compound interest applied at the date of order will become payable.
          </strong>
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-4" tag="h2" size="1" type="heading">
          How do I make a BNPL payment?
        </DialogHeading>

        <DialogText data-testid="bnpl-question-4-answer-1" size="1" tag="p" type="paragraph">
          To make a full or partial payment simply log into your account, choose &quot;Make a payment&quot; select
          &quot;Pay BNPL&quot; and allocate your payment to the specific item(s) you wish to pay off. Alternatively, you
          can call us.
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-5" size="1" tag="h2" type="heading">
          What happens after the delayed payment period?
        </DialogHeading>

        <DialogText data-testid="bnpl-question-5-answer-1" size="1" tag="p" type="paragraph">
          If you have not made any payments towards your BNPL, the outstanding balance plus the lump sum of compound
          interest will be payable across your chosen repayment period. This will now be included in your account
          minimum payment request each month.
        </DialogText>

        <DialogText data-testid="bnpl-question-5-answer-2" size="1" tag="p" type="paragraph">
          If you have made partial payments, but not cleared the full cash price before the end of the delayed payment
          period, the outstanding balance plus a reduced lump sum of compound interest will become payable. The
          repayment amount agreed for the repayment period will remain the same, meaning the repayment period may be
          shorter than originally agreed. If you have paid the cash price in full before the end of the delayed payment
          period, you will not pay any interest.
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-6" size="1" tag="h2" type="heading">
          What is excluded from BNPL?
        </DialogHeading>

        <DialogText data-testid="bnpl-question-6-answer-1" size="1" tag="p" type="paragraph">
          The costs for delivery, installation services and any warranty and insurance products cannot be placed on Buy
          Now Pay Later. BNPL availability is subject to your credit and account status.
        </DialogText>
      </DialogSection>

      <DialogSection>
        <DialogHeading data-testid="bnpl-question-7" tag="h2" size="1" type="heading">
          Do I still have to pay my monthly minimum payment?
        </DialogHeading>

        <DialogText data-testid="bnpl-question-7-answer-1" size="1" tag="p" type="paragraph">
          Yes, allocating payments to BNPL will not cover the minimum payment for your Littlewoods account. If you have
          a non-BNPL balance on your Littlewoods account you will still need to make at least your minimum payment as
          shown on your statement.
        </DialogText>

        <DialogText data-testid="bnpl-question-7-answer-2" size="1" tag="p" type="paragraph">
          Over 18&apos;s only. Credit provided, subject to credit and account status, by Shop Direct Finance Company
          Limited. Registered office: First Floor, Skyways House, Speke Road, Speke, Liverpool, L70 1AB. Authorised and
          regulated by the Financial Conduct Authority.
        </DialogText>
      </DialogSection>
    </>
  );
}

export default LittlewoodsBnplDialogContent;
